export default __webpack_public_path__ + "caa25d0fb540fc392e1e023ae10a80f2.jpg";